export const addZendeskWidget = (): void => {
  const script = document.createElement('script');
  script.id = 'ze-snippet';
  script.src =
    'https://static.zdassets.com/ekr/snippet.js?key=058d70d2-1415-4d8a-951a-90e5ab5bab90';
  script.async = true;
  document.head.appendChild(script);
};
